import confetti from "canvas-confetti";

export function fireConfetti() {
  // confetti({
  //   particleCount: 80,
  //   spread: 70,
  //   origin: { y: 0.75 },
  // });
  confetti({
    particleCount: 70,
    spread: 80,
    startVelocity: 35,
    origin: { x: 0.5, y: 0.5 },
    scalar: 0.9,
  });

  // small follow-up sprinkle
  setTimeout(() => {
    confetti({
      particleCount: 35,
      spread: 120,
      startVelocity: 22,
      origin: { x: 0.5, y: 0.45 },
      scalar: 0.8,
    });
  }, 120);
}

// Optional: if you want a ready button component
export function ConfettiButton({ children, onClick, ...props }) {
  return (
    <button
      {...props}
      onClick={(e) => {
        fireConfetti();
        onClick?.(e);
      }}
    >
      {children}
    </button>
  );
}